import { PARTNER_LEVEL_COLORS } from "@/lib/constants";

const ICON = {
  "Standard": "•",
  "Partner Level 1": "★",
  "Partner Level 2": "★★",
};

const hexToRgba = (hex, a) => {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

export default function PartnerBadge({ level = "Standard", className = "", testId }) {
  const c = PARTNER_LEVEL_COLORS[level] || "#6C757D";
  return (
    <span
      data-testid={testId || "partner-badge"}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider ${className}`}
      style={{ backgroundColor: hexToRgba(c, 0.15), color: c, border: `1px solid ${hexToRgba(c, 0.3)}` }}
    >
      <span className="font-bold leading-none">{ICON[level] || "•"}</span>
      {level}
    </span>
  );
}
